import type { PropsWithChildren, FC } from 'react';
import { useIntl } from 'react-intl';

import { TopBar } from '@xing-com/crate-layout-top-bar';
import { useDeviceInfo } from '@xing-com/crate-xinglet';

import { LoggedInContent } from './logged-in-content';

export const LoggedInPage: FC<PropsWithChildren> = ({ children }) => {
  const { isWebview } = useDeviceInfo();
  const { formatMessage } = useIntl();

  if (isWebview) {
    return <LoggedInContent>{children}</LoggedInContent>;
  }

  return (
    <>
      <TopBar
        title={formatMessage({ id: 'SE_LABEL_COMPANIES' })}
        type="subheader"
      />
      <LoggedInContent>{children}</LoggedInContent>
    </>
  );
};
